import BookList from '@/controllers/book_library/book-list.js';

export default {
  extends: BookList,
}
